// removed by extract-text-webpack-plugin
module.exports = {"Mackerel":"#D2D6D9","White":"#FFFFFF","BlueBase":"#615CFF","ScreenMLMin":"(min-width: 1025px)","SpacingXXS":"5px","fixedMobileCTAContainer":"G413bb0"};